"use client"

import { useState, useEffect } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

interface VideoNavigationProps {
  currentProgress: number
  onProgressChange: (progress: number) => void
  onNext: () => void
  onPrevious: () => void
  hasNext: boolean
  hasPrevious: boolean
}

export function VideoNavigation({
  currentProgress,
  onProgressChange,
  onNext,
  onPrevious,
  hasNext,
  hasPrevious,
}: VideoNavigationProps) {
  const [progress, setProgress] = useState(currentProgress)

  useEffect(() => {
    setProgress(currentProgress)
  }, [currentProgress])

  const handleProgressChange = (value: number) => {
    setProgress(value)
    onProgressChange(value)
  }

  return (
    <div className="bg-slate-100 rounded-lg border border-slate-200 p-6 mb-6">
      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-slate-700">Course Progress</span>
          <span className="text-sm text-slate-500">{progress}%</span>
        </div>
        <div className="w-full bg-slate-200 rounded-full h-3">
          <div
            className="bg-blue-600 h-3 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-between items-center">
        <button
          onClick={onPrevious}
          disabled={!hasPrevious}
          className="flex items-center gap-2 px-4 py-2 text-slate-700 bg-slate-100 rounded-lg hover:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors min-h-[44px]"
        >
          <ChevronLeft className="w-5 h-5" />
          Previous
        </button>

        <button
          onClick={onNext}
          disabled={!hasNext}
          className="flex items-center gap-2 px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors min-h-[44px]"
        >
          Next
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}